import React, { useState, Fragment, useEffect } from "react";
import { Navigation } from "baseui/side-navigation";
import { styled, useStyletron } from "baseui";
import { useHistory, useLocation } from "react-router-dom";
import { Button, SHAPE } from "baseui/button";
import Plus from "baseui/icon/plus";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
const StyledUl = styled("ul", (props) => ({
  paddingLeft: "5px",
  margin: "5px",
  // borderRight: "2px solid",
  height: "100%",
}));

function UserAccountSidebarView({ items, onSelectedChanged }) {
  const { css } = useStyletron();
  const [activeItemId, setActiveItemId] = useState(items[0].itemId);
  const history = useHistory();
  const location = useLocation();
  
  useEffect(() => {
    setActiveItemId(location.pathname);
    onSelectedChanged(location.pathname);
  }, [location.pathname]);
  return (
    <div>
      <StyledUl>
        <Navigation
          items={items}
          activeItemId={activeItemId}
          onChange={({ event, item }) => {
            event.preventDefault();
            setActiveItemId(item.itemId);
            onSelectedChanged(item.itemId);
            history.push(item.itemId);
          }}
          mapItem={(item) => ({ title: item.title, itemId: item.itemId })}
          overrides={{
            NavLink: {
              style: ({ $theme }) => ({
                textDecoration: "none!important",              }),
            },
            NavItem: {
              style: ({ $active, $theme }) => {
                if (!$active) {
                  return {
                    ':hover': {
                      color: $theme.colors.accent,
                    },
                  };
                }
                return {
                  backgroundColor: $theme.colors.accent,
                  borderLeftColor: $theme.colors.accent,
                  color: $theme.colors.mono900,
                  ':hover': {
                    color: $theme.colors.accent400,
                  },
                };
              },
            },
          }}
        />
      </StyledUl>
    </div>
  );
}

export default UserAccountSidebarView;
